import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface CellBadgeValueProps {
  badgeValue: number;
  isSelected?: boolean;
  className?: string;
  isCompact?: boolean;
}

/*
 * Style.
 */

interface BadgeStyleProps {
  $badgeValue: number;
  $isSelected?: boolean;
}

const StyledBadgeDiv = styled.div<BadgeStyleProps>`
  flex-shrink: 0;
  min-width: 16px;
  margin-left: 8px;
  padding: 0 4px;
  border-radius: 8px;

  color: ${(p) => (p.$isSelected ? p.theme.invertedText : p.theme.greys.shade70)};
  ${(p) => addBadgeBackgroundStyles(p)};

  line-height: 16px;
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.semibold};

  ${center()};
`;

function addBadgeBackgroundStyles(props: BadgeStyleProps) {
  if (props.$badgeValue <= 1) {
    return css`
      background-color: transparent;
    `;
  }

  return css`
    background-color: ${(p) => (props.$isSelected ? p.theme.alphas.white30 : p.theme.greys.shade30)};
  `;
}

/*
 * Component.
 */

export const CellBadgeValue: FC<CellBadgeValueProps> = (props) => {
  if (props.isCompact && props.badgeValue <= 1) {
    return null;
  }

  return (
    <StyledBadgeDiv className={props.className} $isSelected={props.isSelected} $badgeValue={props.badgeValue}>
      {props.badgeValue > 1 && props.badgeValue}
    </StyledBadgeDiv>
  );
};
